module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry0"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312877705_Int01#Int01"
    }
  }, [_vm._v("Introduction by David Langford")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry1"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312877705_The02#The02"
    }
  }, [_vm._v("The Secret History of Sector General")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry2"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312877705_pt01#pt01"
    }
  }, [_vm._v("Ambulance Ship")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry4"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312877705_ch01#ch01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 1: Spacebird")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry5"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780312877705_ch02#ch02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 2: Contagion")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry6"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 3: Quarantine")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry7"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 4: Recovery")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry8a"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_pt02#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sector General")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Accident")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Survivor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Investigation")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Combined Operation")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "contentsEntry14a"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_pt03#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Star Healer")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry31"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry32"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry33"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 19")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry34"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 20")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry35"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312877705_ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 21")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e7c661","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312877705_con01.vue
// module id = 66
// module chunks = 0